module.exports = __webpack_public_path__ + "static/media/Sunburst.fd183ee3.svg";